import { useState } from "react";
import { usePublicSiteData } from "./PublicSiteContext";
import PublicSectionTitle from "./PublicSectionTitle";

const PublicTestimonials = () => {
  const website = usePublicSiteData();
  const [index, setIndex] = useState(0);

  const list = website?.testimonials ?? [];
  const count = list.length;
  const next = () => setIndex((i) => (i + 1) % count);
  const prev = () => setIndex((i) => (i - 1 + count) % count);

  const visible =
    count >= 3
      ? [(index - 1 + count) % count, index, (index + 1) % count]
      : list.map((_, i) => i);

  return (
    <section className="psite-section" id="testimonials">
      <div className="psite-section__inner">
        <PublicSectionTitle title="What Our Clients Say" />
        {count > 0 ? (
          <div className="psite-testimonials">
            {count >= 3 && (
              <button
                className="psite-carousel__arrow psite-carousel__arrow--prev"
                onClick={prev}
                aria-label="Previous testimonials"
              >
                ‹
              </button>
            )}
            {visible.map((idx, slot) => {
              const item = list[idx];
              const active = count >= 3 ? slot === 1 : idx === index;
              return (
                <div
                  key={`${item.clientName}-${idx}`}
                  className={`psite-testimonial ${active ? "psite-testimonial--active" : ""}`}
                >
                  <p className="psite-testimonial__text">“{item.reviewText}”</p>
                  <p className="psite-testimonial__name">{item.clientName}</p>
                  {item.rating ? (
                    <p className="psite-testimonial__rating">
                      {"★".repeat(item.rating)}
                    </p>
                  ) : null}
                </div>
              );
            })}
            {count >= 3 && (
              <button
                className="psite-carousel__arrow psite-carousel__arrow--next"
                onClick={next}
                aria-label="Next testimonials"
              >
                ›
              </button>
            )}
          </div>
        ) : (
          <p className="psite-section__empty">
            Testimonials will appear here once published.
          </p>
        )}
      </div>
    </section>
  );
};

export default PublicTestimonials;